const $ = jQuery;

// HUBSPOT FORMS
$(document).ready(() => {
	$('[data-hubspot-form]').each(function () {
		const $this = $(this);
		if ($(this).attr('data-hubspot-form')) {
			if (!$(this).attr('id'))
				$(this).attr('id', 'hubspot-form--' + $(this).attr('data-hubspot-form'));
			const hubspotVars = {
				portalId: $(this).attr('data-hubspot-portal-id'),
				formId: $(this).attr('data-hubspot-form'),
				target: '#' + $(this).attr('id'),
				cssRequired: '',
				css: '',
				locale: $('html').attr('lang'),
				onFormReady() {
					const formUrlField = $this.find('[name="form_submitted_url"]');
					const webinarField = $this.find('[name="downloaded_webinar_name"]');
					if (formUrlField.length) {
						formUrlField.val(window.location.href);
					}
					if (webinarField.length) {
						webinarField.val($('h1').text());
					}
				},
				onFormSubmit() {
					if ($this.is('[data-gated-content-form]')) {
						$this.parents('.block-gated-content-form').addClass('active');
					}
				},
				onFormSubmitted() {
					// EXAMPLE OF CUSTOM HANDLING ON SUBMIT
				},
			};

			if ($(this).attr('data-css') !== undefined) hubspotVars.css = $(this).attr('data-css');
			// eslint-disable-next-line no-undef
			hbspt.forms.create(hubspotVars);
		}
	});
});
